import "./index.scss";
import "reflect-metadata";
import React from "react";
import ReactDOM from "react-dom";
import { App } from "./shell/app";
ReactDOM.render(React.createElement(App, null), document.getElementById("root"));
